module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cFIVf"))).then(() => parcelRequire('d0iPb'));